module.exports = __webpack_public_path__ + "img/boy.21c6560c.png";